// extracted by mini-css-extract-plugin
module.exports = {"deviceRight":"SelectDevice_deviceRight__cJheT","deviceLeft":"SelectDevice_deviceLeft__3mkud"};